import { render, staticRenderFns } from "./TreinadorAgenda.vue?vue&type=template&id=61f5c406&"
import script from "./TreinadorAgenda.vue?vue&type=script&lang=js&"
export * from "./TreinadorAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports